<template>
	<div class="catcard">
		<div class="catcard__head">
			<div class="catcard__new" v-if="item.seria.discount !== 0">Цена указана со скидкой {{ item.seria.discount }}%</div>
			<div class="catcard__new" v-if="item.seria.isnew == 1">NEW</div>
			<div class="catcard__new" v-if="item.seria.discount == 0 && item.seria.isnew == 0">TOP</div>
			<!--<div class="catcard__accia" uk-tooltip="При покупке трех оправ четвертая в подарок">Акция</div>-->
		</div>
		<div class="catcard__image">
			<a :href="url + '/catalog/' + item.id + '?col=' + getColorId()">
				<img :data-src="getFn()" alt="" uk-img>
			</a>
		</div>
		<div class="catcard__brandcolors">
			<div class="catcard__logo" :uk-tooltip="'Бренд ' + item.seria.brand.title">
				<img v-if="item.seria.brand.image" :src="item.seria.brand.image.path" alt="">
			</div>
			<div class="catcard__colors">
				<ul class="uk-subnav uk-subnav-pill" uk-switcher>
					<li v-for="col, i in item.oprava_colors" class="catcard__color" :uk-tooltip="'Цвет ' + retColor(col, 'title')" :style="'background-color:' + retColor(col, 'code')" @click='currentColor = i'>
						<a href="#"></a></li>
				</ul>
			</div>
		</div>
		<hr>
		<div class="catcard__desc">
			<div class="catcard__model">
				серия {{ item.seria.title }}
				<small>
					<span>{{ item.title}}, </span>
					<span v-if="item.oprava_colors[currentColor] && item.oprava_colors[currentColor].title">{{ item.oprava_colors[currentColor].title }}, </span>
					<span>{{ item.occular_size }}#{{ item.nose_size }}</span>
				</small>
			</div>
			<div class="catcard__price" v-if="user">{{ showPrice | cifer }} ₽</div>
      <div class="catcard__accia" v-else>Зарегистрируйтесь,<br>чтобы узнать цену.</div>
			<a class="catcard__hover" :href="url + '/catalog/' + item.id + '?col=' + getColorId()">
				<img :src="url + '/themes/oprava/assets/img/ico-zoom.svg'" alt="">
				<span>Смотреть цвета <br class="uk-visible@s">и характеристики модели</span>
			</a>
		</div>
	</div>
</template>

<script>
  import { product } from "../mixins/product";
  import { finance } from "../mixins/finance";
  import { bus } from './bus.js'

  export default {
    name: "cat-card",
    mixins: [product, finance],
    props: {
      item: '',
	    prepay: '',
      user: null
    },
    data() {
      return {
        currentColor: 0,
        url: '',
      }
    },
    methods: {

    },
    mounted() {
      this.url = this.$parent.url;
    }
  }
</script>


// WEBPACK FOOTER //
// themes/oprava/src/js/components/commerce/cat-card.vue